import { useGate, useStore } from 'effector-react'
import { useMemo } from 'react'
import {
  DocumentBasedRegistration,
  documentBasedRegistrationStepModel,
  useTitle,
} from '~/features/DocumentBasedRegistration'
import { PageContainer } from '~/shared/ui/PageContainer'

export const DocumentBasedRegistrationPage = () => {
  useGate(documentBasedRegistrationStepModel.Gate)

  const {
    isDriverLicenseStep,
    isAdditionalDataStep,
    isConfirmCodeStep,
    isErrorStep,
    isCorrectionStep,
  } = useStore(documentBasedRegistrationStepModel.$currentStepFlags)

  const title = useTitle()

  const pageContainerProps = useMemo(() => {
    return {
      ...(isDriverLicenseStep || isAdditionalDataStep
        ? { onBack: documentBasedRegistrationStepModel.goToBackStep }
        : {}),
      ...(isConfirmCodeStep
        ? {
            contentFillColor: null,
            onBack: documentBasedRegistrationStepModel.goToBackStep,
          }
        : {}),
      ...(isErrorStep
        ? { onBack: documentBasedRegistrationStepModel.goToConfirmStep }
        : {}),
      ...(isCorrectionStep
        ? { onBack: documentBasedRegistrationStepModel.goToBackStep }
        : {}),
    }
  }, [
    isAdditionalDataStep,
    isConfirmCodeStep,
    isDriverLicenseStep,
    isErrorStep,
    isCorrectionStep,
  ])

  return (
    <PageContainer
      title='Регистрация'
      backTitle={title}
      canBack
      {...pageContainerProps}
    >
      <DocumentBasedRegistration />
    </PageContainer>
  )
}
